/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as SidebarRouteImport } from './routes/_sidebar'
import { Route as LoginRouteImport } from './routes/login'
import { Route as SidebarMissionMissionIdRouteRouteImport } from './routes/_sidebar.mission/$missionId/route'
import { Route as SidebarMissionOverviewTabRouteImport } from './routes/_sidebar.mission/overview.$tab'

const IndexLazyRouteImport = createFileRoute('/')()
const BrukermanualLazyRouteImport = createFileRoute('/brukermanual')()
const DevIndexLazyRouteImport = createFileRoute('/dev/')()
const SidebardashboardDashboardLazyRouteImport = createFileRoute(
  '/_sidebar/(dashboard)/dashboard',
)()
const SidebarVesselsIndexLazyRouteImport =
  createFileRoute('/_sidebar/vessels/')()
const SidebardashboardDashboardVesselIdLazyRouteImport = createFileRoute(
  '/_sidebar/(dashboard)/dashboard/$vesselId',
)()
const SidebarMissionOverviewIndexLazyRouteImport = createFileRoute(
  '/_sidebar/mission/overview/',
)()
const SidebarSettingsWebhooksIndexLazyRouteImport = createFileRoute(
  '/_sidebar/settings/webhooks/',
)()
const SidebarSettingsWebhooksWebhookIdLazyRouteImport = createFileRoute(
  '/_sidebar/settings/webhooks/$webhookId',
)()
const SidebarSettingsWebhooksNewLazyRouteImport = createFileRoute(
  '/_sidebar/settings/webhooks/new',
)()
const SidebarMissionMissionIdReportIndexLazyRouteImport = createFileRoute(
  '/_sidebar/mission/$missionId/report/',
)()
const SidebarMissionMissionIdSeilelinjeIndexLazyRouteImport = createFileRoute(
  '/_sidebar/mission/$missionId/seilelinje/',
)()

const IndexLazyRoute = IndexLazyRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/index.lazy').then((d) => d.Route))
const SidebarRoute = SidebarRouteImport.update({
  id: '/_sidebar',
  getParentRoute: () => rootRouteImport,
} as any)
const BrukermanualLazyRoute = BrukermanualLazyRouteImport.update({
  id: '/brukermanual',
  path: '/brukermanual',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/brukermanual.lazy').then((d) => d.Route))
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/login.lazy').then((d) => d.Route))
const DevIndexLazyRoute = DevIndexLazyRouteImport.update({
  id: '/dev/',
  path: '/dev/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/dev/index.lazy').then((d) => d.Route))
const SidebardashboardDashboardLazyRoute =
  SidebardashboardDashboardLazyRouteImport.update({
    id: '/(dashboard)/dashboard',
    path: '/dashboard',
    getParentRoute: () => SidebarRoute,
  } as any).lazy(() =>
    import('./routes/_sidebar.(dashboard)/dashboard.lazy').then((d) => d.Route),
  )
const SidebarMissionMissionIdRouteRoute =
  SidebarMissionMissionIdRouteRouteImport.update({
    id: '/mission/$missionId',
    path: '/mission/$missionId',
    getParentRoute: () => SidebarRoute,
  } as any).lazy(() =>
    import('./routes/_sidebar.mission/$missionId/route.lazy').then(
      (d) => d.Route,
    ),
  )
const SidebarVesselsIndexLazyRoute = SidebarVesselsIndexLazyRouteImport.update({
  id: '/vessels/',
  path: '/vessels/',
  getParentRoute: () => SidebarRoute,
} as any).lazy(() =>
  import('./routes/_sidebar.vessels/index.lazy').then((d) => d.Route),
)
const SidebardashboardDashboardVesselIdLazyRoute =
  SidebardashboardDashboardVesselIdLazyRouteImport.update({
    id: '/$vesselId',
    path: '/$vesselId',
    getParentRoute: () => SidebardashboardDashboardLazyRoute,
  } as any).lazy(() =>
    import('./routes/_sidebar.(dashboard)/dashboard.$vesselId.lazy').then(
      (d) => d.Route,
    ),
  )
const SidebarMissionOverviewIndexLazyRoute =
  SidebarMissionOverviewIndexLazyRouteImport.update({
    id: '/mission/overview/',
    path: '/mission/overview/',
    getParentRoute: () => SidebarRoute,
  } as any).lazy(() =>
    import('./routes/_sidebar.mission/overview.index.lazy').then(
      (d) => d.Route,
    ),
  )
const SidebarMissionOverviewTabRoute =
  SidebarMissionOverviewTabRouteImport.update({
    id: '/mission/overview/$tab',
    path: '/mission/overview/$tab',
    getParentRoute: () => SidebarRoute,
  } as any).lazy(() =>
    import('./routes/_sidebar.mission/overview.$tab.lazy').then((d) => d.Route),
  )
const SidebarSettingsWebhooksIndexLazyRoute =
  SidebarSettingsWebhooksIndexLazyRouteImport.update({
    id: '/settings/webhooks/',
    path: '/settings/webhooks/',
    getParentRoute: () => SidebarRoute,
  } as any).lazy(() =>
    import('./routes/_sidebar.settings/webhooks/index.lazy').then(
      (d) => d.Route,
    ),
  )
const SidebarSettingsWebhooksWebhookIdLazyRoute =
  SidebarSettingsWebhooksWebhookIdLazyRouteImport.update({
    id: '/settings/webhooks/$webhookId',
    path: '/settings/webhooks/$webhookId',
    getParentRoute: () => SidebarRoute,
  } as any).lazy(() =>
    import('./routes/_sidebar.settings/webhooks/$webhookId.lazy').then(
      (d) => d.Route,
    ),
  )
const SidebarSettingsWebhooksNewLazyRoute =
  SidebarSettingsWebhooksNewLazyRouteImport.update({
    id: '/settings/webhooks/new',
    path: '/settings/webhooks/new',
    getParentRoute: () => SidebarRoute,
  } as any).lazy(() =>
    import('./routes/_sidebar.settings/webhooks/new.lazy').then((d) => d.Route),
  )
const SidebarMissionMissionIdReportIndexLazyRoute =
  SidebarMissionMissionIdReportIndexLazyRouteImport.update({
    id: '/report/',
    path: '/report/',
    getParentRoute: () => SidebarMissionMissionIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_sidebar.mission/$missionId/report/index.lazy').then(
      (d) => d.Route,
    ),
  )
const SidebarMissionMissionIdSeilelinjeIndexLazyRoute =
  SidebarMissionMissionIdSeilelinjeIndexLazyRouteImport.update({
    id: '/seilelinje/',
    path: '/seilelinje/',
    getParentRoute: () => SidebarMissionMissionIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_sidebar.mission/$missionId/seilelinje/index.lazy').then(
      (d) => d.Route,
    ),
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexLazyRoute
  '/login': typeof LoginRoute
  '/brukermanual': typeof BrukermanualLazyRoute
  '/dev/': typeof DevIndexLazyRoute
  '/mission/$missionId': typeof SidebarMissionMissionIdRouteRouteWithChildren
  '/dashboard': typeof SidebardashboardDashboardLazyRouteWithChildren
  '/vessels/': typeof SidebarVesselsIndexLazyRoute
  '/mission/overview/$tab': typeof SidebarMissionOverviewTabRoute
  '/dashboard/$vesselId': typeof SidebardashboardDashboardVesselIdLazyRoute
  '/settings/webhooks/$webhookId': typeof SidebarSettingsWebhooksWebhookIdLazyRoute
  '/settings/webhooks/new': typeof SidebarSettingsWebhooksNewLazyRoute
  '/mission/overview/': typeof SidebarMissionOverviewIndexLazyRoute
  '/settings/webhooks/': typeof SidebarSettingsWebhooksIndexLazyRoute
  '/mission/$missionId/report/': typeof SidebarMissionMissionIdReportIndexLazyRoute
  '/mission/$missionId/seilelinje/': typeof SidebarMissionMissionIdSeilelinjeIndexLazyRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexLazyRoute
  '/login': typeof LoginRoute
  '/brukermanual': typeof BrukermanualLazyRoute
  '/dev': typeof DevIndexLazyRoute
  '/mission/$missionId': typeof SidebarMissionMissionIdRouteRouteWithChildren
  '/dashboard': typeof SidebardashboardDashboardLazyRouteWithChildren
  '/vessels': typeof SidebarVesselsIndexLazyRoute
  '/mission/overview/$tab': typeof SidebarMissionOverviewTabRoute
  '/dashboard/$vesselId': typeof SidebardashboardDashboardVesselIdLazyRoute
  '/settings/webhooks/$webhookId': typeof SidebarSettingsWebhooksWebhookIdLazyRoute
  '/settings/webhooks/new': typeof SidebarSettingsWebhooksNewLazyRoute
  '/mission/overview': typeof SidebarMissionOverviewIndexLazyRoute
  '/settings/webhooks': typeof SidebarSettingsWebhooksIndexLazyRoute
  '/mission/$missionId/report': typeof SidebarMissionMissionIdReportIndexLazyRoute
  '/mission/$missionId/seilelinje': typeof SidebarMissionMissionIdSeilelinjeIndexLazyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexLazyRoute
  '/_sidebar': typeof SidebarRouteWithChildren
  '/login': typeof LoginRoute
  '/brukermanual': typeof BrukermanualLazyRoute
  '/dev/': typeof DevIndexLazyRoute
  '/_sidebar/mission/$missionId': typeof SidebarMissionMissionIdRouteRouteWithChildren
  '/_sidebar/(dashboard)/dashboard': typeof SidebardashboardDashboardLazyRouteWithChildren
  '/_sidebar/vessels/': typeof SidebarVesselsIndexLazyRoute
  '/_sidebar/mission/overview/$tab': typeof SidebarMissionOverviewTabRoute
  '/_sidebar/(dashboard)/dashboard/$vesselId': typeof SidebardashboardDashboardVesselIdLazyRoute
  '/_sidebar/settings/webhooks/$webhookId': typeof SidebarSettingsWebhooksWebhookIdLazyRoute
  '/_sidebar/settings/webhooks/new': typeof SidebarSettingsWebhooksNewLazyRoute
  '/_sidebar/mission/overview/': typeof SidebarMissionOverviewIndexLazyRoute
  '/_sidebar/settings/webhooks/': typeof SidebarSettingsWebhooksIndexLazyRoute
  '/_sidebar/mission/$missionId/report/': typeof SidebarMissionMissionIdReportIndexLazyRoute
  '/_sidebar/mission/$missionId/seilelinje/': typeof SidebarMissionMissionIdSeilelinjeIndexLazyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/brukermanual'
    | '/dev/'
    | '/mission/$missionId'
    | '/dashboard'
    | '/vessels/'
    | '/mission/overview/$tab'
    | '/dashboard/$vesselId'
    | '/settings/webhooks/$webhookId'
    | '/settings/webhooks/new'
    | '/mission/overview/'
    | '/settings/webhooks/'
    | '/mission/$missionId/report/'
    | '/mission/$missionId/seilelinje/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/brukermanual'
    | '/dev'
    | '/mission/$missionId'
    | '/dashboard'
    | '/vessels'
    | '/mission/overview/$tab'
    | '/dashboard/$vesselId'
    | '/settings/webhooks/$webhookId'
    | '/settings/webhooks/new'
    | '/mission/overview'
    | '/settings/webhooks'
    | '/mission/$missionId/report'
    | '/mission/$missionId/seilelinje'
  id:
    | '__root__'
    | '/'
    | '/_sidebar'
    | '/login'
    | '/brukermanual'
    | '/dev/'
    | '/_sidebar/mission/$missionId'
    | '/_sidebar/(dashboard)/dashboard'
    | '/_sidebar/vessels/'
    | '/_sidebar/mission/overview/$tab'
    | '/_sidebar/(dashboard)/dashboard/$vesselId'
    | '/_sidebar/settings/webhooks/$webhookId'
    | '/_sidebar/settings/webhooks/new'
    | '/_sidebar/mission/overview/'
    | '/_sidebar/settings/webhooks/'
    | '/_sidebar/mission/$missionId/report/'
    | '/_sidebar/mission/$missionId/seilelinje/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexLazyRoute: typeof IndexLazyRoute
  SidebarRoute: typeof SidebarRouteWithChildren
  LoginRoute: typeof LoginRoute
  BrukermanualLazyRoute: typeof BrukermanualLazyRoute
  DevIndexLazyRoute: typeof DevIndexLazyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_sidebar': {
      id: '/_sidebar'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof SidebarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/brukermanual': {
      id: '/brukermanual'
      path: '/brukermanual'
      fullPath: '/brukermanual'
      preLoaderRoute: typeof BrukermanualLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/': {
      id: '/dev/'
      path: '/dev'
      fullPath: '/dev/'
      preLoaderRoute: typeof DevIndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_sidebar/(dashboard)/dashboard': {
      id: '/_sidebar/(dashboard)/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof SidebardashboardDashboardLazyRouteImport
      parentRoute: typeof SidebarRoute
    }
    '/_sidebar/mission/$missionId': {
      id: '/_sidebar/mission/$missionId'
      path: '/mission/$missionId'
      fullPath: '/mission/$missionId'
      preLoaderRoute: typeof SidebarMissionMissionIdRouteRouteImport
      parentRoute: typeof SidebarRoute
    }
    '/_sidebar/vessels/': {
      id: '/_sidebar/vessels/'
      path: '/vessels'
      fullPath: '/vessels/'
      preLoaderRoute: typeof SidebarVesselsIndexLazyRouteImport
      parentRoute: typeof SidebarRoute
    }
    '/_sidebar/(dashboard)/dashboard/$vesselId': {
      id: '/_sidebar/(dashboard)/dashboard/$vesselId'
      path: '/$vesselId'
      fullPath: '/dashboard/$vesselId'
      preLoaderRoute: typeof SidebardashboardDashboardVesselIdLazyRouteImport
      parentRoute: typeof SidebardashboardDashboardLazyRoute
    }
    '/_sidebar/mission/overview/': {
      id: '/_sidebar/mission/overview/'
      path: '/mission/overview'
      fullPath: '/mission/overview/'
      preLoaderRoute: typeof SidebarMissionOverviewIndexLazyRouteImport
      parentRoute: typeof SidebarRoute
    }
    '/_sidebar/mission/overview/$tab': {
      id: '/_sidebar/mission/overview/$tab'
      path: '/mission/overview/$tab'
      fullPath: '/mission/overview/$tab'
      preLoaderRoute: typeof SidebarMissionOverviewTabRouteImport
      parentRoute: typeof SidebarRoute
    }
    '/_sidebar/settings/webhooks/': {
      id: '/_sidebar/settings/webhooks/'
      path: '/settings/webhooks'
      fullPath: '/settings/webhooks/'
      preLoaderRoute: typeof SidebarSettingsWebhooksIndexLazyRouteImport
      parentRoute: typeof SidebarRoute
    }
    '/_sidebar/settings/webhooks/$webhookId': {
      id: '/_sidebar/settings/webhooks/$webhookId'
      path: '/settings/webhooks/$webhookId'
      fullPath: '/settings/webhooks/$webhookId'
      preLoaderRoute: typeof SidebarSettingsWebhooksWebhookIdLazyRouteImport
      parentRoute: typeof SidebarRoute
    }
    '/_sidebar/settings/webhooks/new': {
      id: '/_sidebar/settings/webhooks/new'
      path: '/settings/webhooks/new'
      fullPath: '/settings/webhooks/new'
      preLoaderRoute: typeof SidebarSettingsWebhooksNewLazyRouteImport
      parentRoute: typeof SidebarRoute
    }
    '/_sidebar/mission/$missionId/report/': {
      id: '/_sidebar/mission/$missionId/report/'
      path: '/report'
      fullPath: '/mission/$missionId/report/'
      preLoaderRoute: typeof SidebarMissionMissionIdReportIndexLazyRouteImport
      parentRoute: typeof SidebarMissionMissionIdRouteRoute
    }
    '/_sidebar/mission/$missionId/seilelinje/': {
      id: '/_sidebar/mission/$missionId/seilelinje/'
      path: '/seilelinje'
      fullPath: '/mission/$missionId/seilelinje/'
      preLoaderRoute: typeof SidebarMissionMissionIdSeilelinjeIndexLazyRouteImport
      parentRoute: typeof SidebarMissionMissionIdRouteRoute
    }
  }
}

interface SidebarMissionMissionIdRouteRouteChildren {
  SidebarMissionMissionIdReportIndexLazyRoute: typeof SidebarMissionMissionIdReportIndexLazyRoute
  SidebarMissionMissionIdSeilelinjeIndexLazyRoute: typeof SidebarMissionMissionIdSeilelinjeIndexLazyRoute
}

const SidebarMissionMissionIdRouteRouteChildren: SidebarMissionMissionIdRouteRouteChildren =
  {
    SidebarMissionMissionIdReportIndexLazyRoute:
      SidebarMissionMissionIdReportIndexLazyRoute,
    SidebarMissionMissionIdSeilelinjeIndexLazyRoute:
      SidebarMissionMissionIdSeilelinjeIndexLazyRoute,
  }

const SidebarMissionMissionIdRouteRouteWithChildren =
  SidebarMissionMissionIdRouteRoute._addFileChildren(
    SidebarMissionMissionIdRouteRouteChildren,
  )

interface SidebardashboardDashboardLazyRouteChildren {
  SidebardashboardDashboardVesselIdLazyRoute: typeof SidebardashboardDashboardVesselIdLazyRoute
}

const SidebardashboardDashboardLazyRouteChildren: SidebardashboardDashboardLazyRouteChildren =
  {
    SidebardashboardDashboardVesselIdLazyRoute:
      SidebardashboardDashboardVesselIdLazyRoute,
  }

const SidebardashboardDashboardLazyRouteWithChildren =
  SidebardashboardDashboardLazyRoute._addFileChildren(
    SidebardashboardDashboardLazyRouteChildren,
  )

interface SidebarRouteChildren {
  SidebarMissionMissionIdRouteRoute: typeof SidebarMissionMissionIdRouteRouteWithChildren
  SidebardashboardDashboardLazyRoute: typeof SidebardashboardDashboardLazyRouteWithChildren
  SidebarVesselsIndexLazyRoute: typeof SidebarVesselsIndexLazyRoute
  SidebarMissionOverviewTabRoute: typeof SidebarMissionOverviewTabRoute
  SidebarSettingsWebhooksWebhookIdLazyRoute: typeof SidebarSettingsWebhooksWebhookIdLazyRoute
  SidebarSettingsWebhooksNewLazyRoute: typeof SidebarSettingsWebhooksNewLazyRoute
  SidebarMissionOverviewIndexLazyRoute: typeof SidebarMissionOverviewIndexLazyRoute
  SidebarSettingsWebhooksIndexLazyRoute: typeof SidebarSettingsWebhooksIndexLazyRoute
}

const SidebarRouteChildren: SidebarRouteChildren = {
  SidebarMissionMissionIdRouteRoute:
    SidebarMissionMissionIdRouteRouteWithChildren,
  SidebardashboardDashboardLazyRoute:
    SidebardashboardDashboardLazyRouteWithChildren,
  SidebarVesselsIndexLazyRoute: SidebarVesselsIndexLazyRoute,
  SidebarMissionOverviewTabRoute: SidebarMissionOverviewTabRoute,
  SidebarSettingsWebhooksWebhookIdLazyRoute:
    SidebarSettingsWebhooksWebhookIdLazyRoute,
  SidebarSettingsWebhooksNewLazyRoute: SidebarSettingsWebhooksNewLazyRoute,
  SidebarMissionOverviewIndexLazyRoute: SidebarMissionOverviewIndexLazyRoute,
  SidebarSettingsWebhooksIndexLazyRoute: SidebarSettingsWebhooksIndexLazyRoute,
}

const SidebarRouteWithChildren =
  SidebarRoute._addFileChildren(SidebarRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexLazyRoute: IndexLazyRoute,
  SidebarRoute: SidebarRouteWithChildren,
  LoginRoute: LoginRoute,
  BrukermanualLazyRoute: BrukermanualLazyRoute,
  DevIndexLazyRoute: DevIndexLazyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
